import { Flex, useStyles, Container } from '@archipro-design/aria';
import * as S from './ArticleFooter.style';
import { ClientOnly } from 'remix-utils';
import RecentlyViewed from '@modules/articles/component/recently-viewed/RecentlyViewed';
import TopReadArticles from '../top-read-articles/TopReadArticles';
import RelatedArticles from '../related-articles/RelatedArticles';
import LatestArticlesFooter from '../latest-article-footer/LatestArticleFooter';
import type { ProfessionalInitialResult } from '~/modules/professional/hook/use-professional-initial-route-data';
import CompanyProfile from '~/modules/company-profile/CompanyProfile';
import { useEnquiryVisibility } from '~/modules/enquiry/hooks/use-enquiry-visibility';
import { SpecifierLoginPrompt } from '~/modules/enquiry/component/specifier-login-prompt/SpecifierLoginPrompt';

type ArticleEnquiryProfessional = Pick<
    ProfessionalInitialResult,
    | 'ID'
    | 'Title'
    | 'CompanyLogo'
    | 'LibraryLocations'
    | 'LogoBackgroundColor'
    | 'Link'
    | 'Website'
    | 'branchOptions'
    | 'ArchiproEditorialAccount'
    | 'primaryCTA'
    | 'CustomEnquiryMessage'
    | 'EnquiryMessageOverrideEnabled'
    | 'EnquiryMessagePlaceholder'
    | 'AvailableForWork'
    | 'EnquiryAudience'
>;
interface ArticleFooterProps {
    professional: ArticleEnquiryProfessional;
    articleID: number;
    articleCategoryLink: string;
}

const ArticleFooter = ({
    professional,
    articleID,
    articleCategoryLink,
}: ArticleFooterProps) => {
    const { css } = useStyles();
    const { showEnquiryForm, showSpecifierLoginPrompt } =
        useEnquiryVisibility(professional);

    return (
        <Flex column={true} className={css(S.ArticleFooterContainer)}>
            <ClientOnly fallback={<></>}>
                {() => (
                    <Container>
                        {!professional.ArchiproEditorialAccount && (
                            <div
                                className={css(S.ArticleFooterEnquiryContainer)}
                            >
                                {showSpecifierLoginPrompt && (
                                    <SpecifierLoginPrompt
                                        professionalName={professional.Title}
                                        itemDescription="this article"
                                        showBottomBorder={false}
                                    />
                                )}
                                <CompanyProfile
                                    data={{
                                        Professional: professional,
                                        siteTreeID: articleID,
                                        itemType: 'article',
                                        website: professional.Website,
                                        primaryCTA: professional.primaryCTA,
                                    }}
                                    showEnquiryForm={showEnquiryForm}
                                />
                            </div>
                        )}

                        <RelatedArticles
                            articleCategoryLink={articleCategoryLink}
                        />
                        <TopReadArticles />
                        <LatestArticlesFooter />
                        <RecentlyViewed />
                    </Container>
                )}
            </ClientOnly>
        </Flex>
    );
};
export default ArticleFooter;
